module.exports = "/images/bancoazteca.svg?3f21e49b8a29ce05baa10634e847a5f9";